<template>
  <div class="dropdown-container" @mouseleave="active = false">
    <template v-if="$auth.ready()" class="big">
      <template v-if="$auth.check()">
        <div @click="active = !active" class="dropdown-btn item" :class="{ active: active }">
          {{ $t("header.dashboard") }}
        </div>
        <div v-if="active" class="dropdown-items">
          <router-link class="item" :to="{ name: 'dashboard' }">
            {{ $t("header.see") }}
          </router-link>
          <router-link class="item" :to="{
              name: 'model.username',
              params: { username: `@${user.username}` },
            }">
            {{ $t("header.my_wall") }}
          </router-link>
          <a class="item" :href="WEBSTARPANEL_URL">{{ $t("header.my_panel") }}</a>
          <a class="item" v-if="chatUrl" :href="chatUrl">{{ $t("header.my_chat") }}</a>
          <a class="item" href="https://www.divasplay.info" target="_blank">
            {{ $t("header.tutorials") }}
          </a>
          <a @click.prevent="$auth.logout()" class="item" href="#">
            {{ $t("header.logout") }}
          </a>
        </div>
      </template>
      <template v-else>
        <div @click="active = !active" class="dropdown-btn item" :class="{ active: active }">
          {{ $t("header.login") }}
        </div>
        <div v-if="active" class="dropdown-items">
          <router-link class="item" :to="{ name: 'login' }">
            {{ $t("header.login_user") }}
          </router-link>
          <a v-if="webstarsPanelUrl" class="item" :href="webstarsPanelUrl">
            {{ $t("header.webstars_panel") }}
          </a>
          <router-link class="item" :to="{ name: 'signup' }">
            {{ $t("header.register") }}
          </router-link>
          <a class="item" href="https://www.divasplay.info" target="_blank">
            {{ $t("header.tutorials") }}
          </a>
        </div>
      </template>

    </template>
    <template v-else>
      <a class="item" href="#">
        {{ $t("loading") }}
      </a>
    </template>
  </div>
</template>
<script>
import resources from "../../resources";

export default {
  name: "NavLogin",
  data() {
    return {
      active: false,
      //   webstarsPanelUrl: process.env.VUE_APP_WEBSTARS_PANEL_URL,
      webstarsPanelUrl: "/login?redirect=webstars-panel",
      WEBSTARPANEL_URL: resources.webstars.HomeUrl(),
    };
  },
  computed: {
    user() {
      if (this.$auth.ready() && this.$auth.check()) {
        return this.$auth.user();
      }
    },
    chatUrl() {
      return this.$store.state.chat_url;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../styles/variables";

.dropdown-container {
  position: relative;
  flex-grow: 1;

  .dropdown-btn {
    cursor: pointer;

    &.active {
      cursor: default;
    }
  }

  .dropdown-items {
    width: 100%;
    position: absolute;
    top: 100%;
    z-index: 99;
    background: var(--background_01);
  }

  .item {
    min-width: 120px;
    display: block;
    text-align: center;
    color: inherit;
    text-decoration: none;
    text-transform: uppercase;
    font-weight: bold;
    font-size: 16px;
    padding: 0.8em 0;
    flex-grow: 1;
    transition: background-color 0.2s ease-in-out;

    &.router-link-active {
      background-color: lighten(#000000, 50);
    }

    // &:hover{
    //     background-color: lighten(#000000, 30);
    // }

    &:hover {
      background-color: var(--pallete_clear_text_color);
      color: var(--pallete_dark_color);
    }
  }
}
</style>
